import { render } from "./RecurrenceEndFeature.vue?vue&type=template&id=37481f22&ts=true"
import script from "./RecurrenceEndFeature.vue?vue&type=script&lang=ts"
export * from "./RecurrenceEndFeature.vue?vue&type=script&lang=ts"

import "./RecurrenceEndFeature.vue?vue&type=style&index=0&id=37481f22&lang=sass"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__